<template>
    <MewsBookingEngine
        v-if="bookerActive"
        :form-data="formData"
        :mews-id="mewsId"
        :mews-ids="mewsIds"
    />
</template>

<script setup lang="ts">
const bookerActive = ref(false);

const formData = reactive({
    location: null,
    date: {
        start: null,
        end: null
    },
    guests: {
        adults: 1,
        kids: 0
    },
    code: ''
});

const mewsId = ref('');
const mewsIds = ref<string[]>([]);
const route = useRoute();

watch(() => route.query, async() => {
    if (route.query.date) {
        // date parameter should be in the format YYYY-MM-DD_to_YYYY-MM-DD
        const dateParam = route.query.date as string;
        const dates = dateParam.split('_to_');

        if (dates.length === 2) {
            // Parse YYYY_MM_DD format explicitly to avoid timezone issues
            const [startYear, startMonth, startDay] = dates[0].split('_').map(Number);
            const [endYear, endMonth, endDay] = dates[1].split('_').map(Number);
            
            const startDate = new Date(startYear, startMonth - 1, startDay);
            const endDate = new Date(endYear, endMonth - 1, endDay);

            formData.date = {
                start: startDate,
                end: endDate
            };
        }
    }

    if (route.query.guests) {
        // guests parameter should be in the format adults-kids-infants
        const guestsParam = route.query.guests as string;
        const guests = guestsParam.split('-').map(Number);

        formData.guests = {
            adults: guests[0] || 1,
            kids: guests[1] || 0
        };
    }

    if (route.query.code) {
        formData.code = route.query.code as string;
    }

    if (route.query.book) {
        const mewsIdValue = route.query.book as string;

        if (mewsIdValue) {
            // if mewsIdValue is a comma-separated list, split it into an array
            const mewsIdArray = mewsIdValue.split(',');

            if (mewsIdArray.length === 1) {
                mewsId.value = mewsIdValue;
            }

            if (mewsIdArray.length > 1) {
                mewsIds.value = mewsIdArray;
            }

            // Only auto-open if both ?book and ?autoopen are present
            if (route.query.autoopen === undefined) {
                return;
            }

            if (bookerActive.value) {
                return;
            }

            bookerActive.value = false;

            setTimeout(() => {
                bookerActive.value = true;
            }, 500);
        }
    }
}, { immediate: true });
</script>
